import SectionContentWrapper from "@/components/Shared/SectionContentWrapper";
import VideoSliderItem from "@/components/VideoSlider/VideoSliderItem";
import React, { useState } from "react";
import styled from "styled-components";
import { useWindowSize } from "@uidotdev/usehooks";
import { LayoutGroup, AnimateSharedLayout, AnimatePresence } from "framer-motion";
import useEmblaCarousel, { type UseEmblaCarouselType } from "embla-carousel-react";
import MobileVideoSlider from "@/components/VideoSlider/MobileVideoSlider";

const VideoSliderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100vw;
  overflow-x: hidden;
`;

const VideoSliderWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 18px;
  max-width: 1136px;
  transform-origin: left;
  padding-bottom: 68px;
`;

export default function VideoSlider({ sectionTitle, videoItems }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [muted, setMuted] = useState(true);
  const { width } = useWindowSize();

  const handleProgression = () => {
    if (activeIndex === videoItems.length - 1) {
      setActiveIndex(0);
    } else {
      setActiveIndex(activeIndex + 1);
    }
  };

  return (
    <SectionContentWrapper sectionTitle={sectionTitle} theme={"dark"} darkMode>
      <VideoSliderContainer>
        {width > 768 ? (
          <AnimatePresence mode='sync'>
            <VideoSliderWrapper>
              {videoItems.map((videoItem, index) => (
                <VideoSliderItem
                  key={videoItem.id}
                  videoItem={videoItem}
                  active={index === activeIndex}
                  setActiveIndex={setActiveIndex}
                  handleProgression={handleProgression}
                  index={index}
                  muted={muted}
                  setMuted={setMuted}
                />
              ))}
            </VideoSliderWrapper>
          </AnimatePresence>
        ) : (
          <MobileVideoSlider
            videoItems={videoItems}
            activeIndex={activeIndex}
            handleProgression={handleProgression}
            muted={muted}
            setMuted={setMuted}
            onSlideChange={setActiveIndex}
          />
        )}
      </VideoSliderContainer>
    </SectionContentWrapper>
  );
}
